import { Shape }                 from '@tokamap/core';
import currentEditorStore        from '@/TokamapEditor/stores/currentEditorStore';
import currentProjectEditorStore from '@/TokamapEditor/stores/currentProjectEditorStore';
import projectShapesStore        from '@/TokamapEditor/stores/projectShapesStore';
import shapePlaceId              from '@/TokamapEditor/helpers/shapePlaceId';

/** Formes du point d'intérêt sur cette carte et sur les autres. `shown` : le compteur a quelque chose
 * à dire, ce qui n'est pas le cas d'une forme seule sur toutes les cartes (cas le plus courant). */
export default function placeShapesCount(placeId: string) {
	const projectEditor = currentProjectEditorStore.get;
	const currentMapId = String(projectEditor.currentMap.id);

	const isOfPlace = (s: Shape) => shapePlaceId(s) === placeId;

	const here = currentEditorStore.allShapes.filter(isOfPlace);

	const elsewhere = projectEditor.mapCollection.models
		.filter(map => !!map.id && String(map.id) !== currentMapId)
		.reduce((sum, map) => sum + projectShapesStore.shapesOfMap(map.id).filter(isOfPlace).length, 0);

	return { here, elsewhere, shown: here.length > 1 || !!elsewhere };
}
